import React from 'react'
import * as styles from './statistics-block.module.scss'

interface StatisticsBlockProps {
    icon: React.FC<React.SVGProps<SVGSVGElement>>
    label: string
    value: string
    className?: string
    onClick?: () => void
}

export const StatisticsBlock: React.FC<StatisticsBlockProps> = ({ className, icon: Icon, label, value, onClick }) => {
    return (
        <div onClick={onClick} className={[styles.statistics_wrapper, className].filter(Boolean).join(' ')}>
            <div className={styles.statistics_icon}>
                <Icon width={32} height={32} />
            </div>
            <div className={styles.statistics_info}>
                <div className='text-base leading-[16px] screen:text-lg screen:leading-[25px] mb-1 screen:mb-2'>{label}</div>
                <div className='text-2xl screen:text-[32px] leading-[24px] screen:leading-[32px] font-semibold'>{value}</div>
            </div>
        </div>
    )
}